import axiosInstance from '@/app/api/axiosInstance';

import {
  DeliveryChallanDetail,
  DeliveryChallanStatus,
  DeliveryChallanSummary,
  PaginatedResponse,
} from '@/app/types/deliveryChallan';

export interface DeliveryChallanQuery {
  endDate?: string;
  limit?: number;
  skip?: number;
  startDate?: string;
  status?: DeliveryChallanStatus;
}

export const getAllowedNextStatuses = (
  currentStatus: DeliveryChallanStatus,
): DeliveryChallanStatus[] => {
  switch (currentStatus) {
    case 'packed':
      return ['shipped'];
    case 'shipped':
      return ['delivered'];
    default:
      return [];
  }
};

export const fetchDeliveryChallans = async (
  query: DeliveryChallanQuery = {},
): Promise<PaginatedResponse<DeliveryChallanSummary>> => {
  const response = await axiosInstance.get<PaginatedResponse<DeliveryChallanSummary>>(
    '/field-agent/my-delivery-challans',
    {
      params: {
        end_date: query.endDate,
        limit: query.limit,
        skip: query.skip,
        start_date: query.startDate,
        status: query.status,
      },
    },
  );

  return response.data;
};

export const fetchDeliveryChallanDetail = async (
  challanId: number,
): Promise<DeliveryChallanDetail> => {
  const response = await axiosInstance.get<DeliveryChallanDetail>(
    `/field-agent/my-delivery-challans/${challanId}`,
  );

  return response.data;
};

export const updateDeliveryChallanStatus = async (
  challanId: number,
  newStatus: DeliveryChallanStatus,
  notes?: string,
): Promise<DeliveryChallanDetail> => {
  const response = await axiosInstance.patch<DeliveryChallanDetail>(
    `/field-agent/my-delivery-challans/${challanId}/status`,
    {
      new_status: newStatus,
      notes,
    },
  );

  return response.data;
};
